import * as React from 'react';

import type { TabLayoutProps } from '@/components/pages/event/types/TabLayout';
import SectionSpeakers from '@/components/pages/event/layout/components/SectionSpeakers';

const SpeakersLayout = (props: TabLayoutProps) => {
    const { speakers, event, accentColor } = props;
    const highlightedSpeaker = speakers && speakers.length > 0 ? speakers[0]! : null;

    if (!speakers || speakers.length === 0) {
        return (
            <>
                <div className="p-5 md:p-10 xl:px-20 md:pr-32 h-96">
                    Speakers for <span className="font-semibold">{event.title}</span> are not available, yet. Please
                    follow our socials for updates.
                </div>
            </>
        );
    }

    return (
        <div className="p-5 md:p-10 xl:px-20 md:pr-32 pb-96">
            <SectionSpeakers
                className="bg-white"
                eventSlug={event.slug}
                highlightedSpeaker={highlightedSpeaker}
                speakers={speakers}
                accentColor={accentColor}
                showAllSpeakersLink={false}
            />
        </div>
    );
};

export default SpeakersLayout;
